import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../realize_overrides/components/modal/modal.jsx';

import { ModalActions } from '../../realize_overrides/stores/modal_store';
import ProcessActionRoutes from '../constants/process_action_routes';
import { ProcessActions } from '../reflux/process_store';
import { ProcessAPI } from 'lecom-api';

import ResponseHandler from '../../rest_client/response_handler.js';
import { FlashMessagesActions } from '../../flash_message/reflux/flash_messages_store.js';
import FlashMessages from '../../flash_message/components/flash_messages.jsx';
import RealizeInputAutocomplete from 'realize/components/input/input_autocomplete_realize';

const Realize = {
	i18n: window.Realize.i18n,
	Modal: Modal,
	ModalHeader: window.ModalHeader,
	ModalContent: window.ModalContent,
	ModalFooter: window.ModalFooter
};

export default class AssignActivityToUserModal extends React.Component {
	static propTypes = {
		processIds: PropTypes.object,
		modalId: PropTypes.string,
		isMobile: PropTypes.bool
	};

	static defaultProps = {
		processIds: {},
		modalId: 'assign-activity-to-user-modal',
		isMobile: false
	};

	state = {
		selectedUserId: null,
		confirmButtonEnabled: false
	};

	constructor(props) {
		super(props);

		RealizeInputAutocomplete.prototype.componentDidMount = () => { };
	}

	componentDidMount() {
		if(this.state.selectedUserId) {
			FlashMessagesActions.clear("flash-modal");
		}
	}

	dismissModal() {
		ModalActions.close({ modalId: this.props.modalId });
		FlashMessagesActions.clear("flash-modal");
	}

	handleConfirmButton() {
		const currentProcess = ProcessAPI.currentProcess();

		//TODO: Usar a ProcessAPI para executar a ação
		!!this.state.selectedUserId
			? ProcessActions.assignActivityToUser(currentProcess.storeId, this.props.processIds, this.state.selectedUserId)
			: ResponseHandler.displayWarningFlashMessage(Realize.i18n.t(`activity.assignToUserModal.selectUserWarning`), "flash-modal");
	}

	handleOnSelect(inputId, value, options) {
		const selectedUserId = value[0];

		this.setState({selectedUserId: selectedUserId});
		this.state.confirmButtonEnabled = !!selectedUserId;
	}

	renderInputAutoComplete() {
		const contextPath = window.contextPath || '';
		const url = `${contextPath}${ProcessActionRoutes.GET_USERS}?inactived=false`;
		
		return (
			// <InputAutocomplete
			// 	optionsUrl={url}
			// 	searchParam='name'
			// 	nameField='name'
			// 	valueField='userId'
			// 	optionsParam='_embedded.users'
			// 	clientSideSearch={false}
			// 	onSelect={this.handleOnSelect.bind(this)}
			// 	className='autocomplete-modal-redirect'
			// />
			<RealizeInputAutocomplete
				component="autocomplete"
				optionsUrl={url}
				searchParam='name'
				nameField='name'
				valueField='userId'
				optionsParam='_embedded.users'
				clientSideSearch={false}
				maxOptions={10}
     			maxOptionsParam={'size'}
				onSelect={this.handleOnSelect.bind(this)}
				className='autocomplete-modal-redirect'
			/>
		);
	}

	buildButtonProps(action, label, buttonIcon, buttonStyle, otherProps={}, className) {
		buttonStyle = buttonStyle || 'primary';
		const buttonLabel = Realize.i18n.t(label);

		return Object.assign({
			name:  buttonLabel,
			icon: buttonIcon,
			style: buttonStyle,
			onClick: action,
			className: buttonLabel
		}, otherProps);
	}

	buildDismissButtonProps() {
		return this.buildButtonProps(this.dismissModal.bind(this), 'actions.close', 'close', 'cancel');
	}

	buildConfirmButtonProps() {
		return this.buildButtonProps(this.handleConfirmButton.bind(this), 'actions.confirm', 'done', 'primary', {
			disabled : !this.state.confirmButtonEnabled
		});
	}

	buildButtonsGroupProps() {
		return [
			this.buildConfirmButtonProps(),
			this.buildDismissButtonProps()
		];
	}

	focusAutoComplete(modalId){
		if($(`#${modalId}`).is(':visible') === true){
			$(`#${modalId}_title`).focus();
			const btnClose = $(`#${modalId}`).find('a');
			btnClose.attr('tabIndex', 0);

			btnClose.keydown((e) => {
				if(e.which === 13)
					btnClose[0].click();
			});
		}
	}

	render() {
		setTimeout(() => { this.focusAutoComplete(this.props.modalId)}, 200);
		return (
			<Realize.Modal id={this.props.modalId} resizer={this.setModalContentHeight} isMobile={this.props.isMobile} dismissible={false} className='assign-activity-to-user'>
				<Realize.ModalHeader>
					<span className="h5-custom" tabIndex="0" id={`${this.props.modalId}_title`}>
						{Realize.i18n.t('process.assignToUserModelTitle')}
					</span>
				</Realize.ModalHeader>
				<Realize.ModalContent>
					<FlashMessages id="flash-modal" />
					<div className="input-field">
						{this.renderInputAutoComplete()}
					</div>
				</Realize.ModalContent>
				<Realize.ModalFooter className={'right-align'}>
					<ButtonGroup buttons={this.buildButtonsGroupProps()} />
				</Realize.ModalFooter>
			</Realize.Modal>
		);
	}
}
